const ddmmyyyy = function () {
  var date = new Date(this.valueOf());
  var dd = date.getDate();
  var mm = date.getMonth() + 1;

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    date.getFullYear()
  ].join(".");
};

const ddMM = function () {
  var date = new Date(this.valueOf());
  var monthNames = [
    "янв",
    "фев",
    "мар",
    "апр",
    "мая",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек"
  ];
  var dd = date.getDate();
  var mm = date.getMonth();

  return [(dd > 9 ? "" : "0") + dd, monthNames[mm]].join(" ");
};

const addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

const yyyymmdd = function () {
  var dd = this.getDate();
  var mm = this.getMonth() + 1;

  return [
    this.getFullYear(),
    (mm > 9 ? "" : "0") + mm,
    (dd > 9 ? "" : "0") + dd
  ].join(",");
};

const yyyyddmm = function () {
  var dd = this.getDate();
  var mm = this.getMonth() + 1;

  return [this.getFullYear(),
  (dd > 9 ? '' : '0') + dd,
  (mm > 9 ? '' : '0') + mm
  ].join(',');
}

const mmddyyyy = function () {
  var mm = this.getMonth() + 1;
  var dd = this.getDate();

  return [
    (mm > 9 ? "" : "0") + mm,
    (dd > 9 ? "" : "0") + dd,
    this.getFullYear()
  ].join(",");
};

export default class DateFormat {
  static DAY_SECONDS = 60 * 60 * 24;

  static months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
  ];

  static monthAbbr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  static extendDate() {
    return Object.assign(Date.prototype, {
      ddmmyyyy,
      ddMM,
      addDays,
      yyyymmdd,
      mmddyyyy,
      yyyyddmm
    });
  }

  static smallRange({ day, month, dayEnd, monthEnd }) {
    let leftPart = day + " ";
    if (month !== monthEnd) {
      leftPart += DateFormat.monthAbbr[month] + ". ";
    }
    return leftPart + "- " + dayEnd + " " + DateFormat.monthAbbr[monthEnd];
  }

  static getRange(dtBegin, dtEnd) {
    let leftPart;
    leftPart = dtBegin.getDate() + " ";
    if (dtBegin.getMonth() !== dtEnd.getMonth()) {
      leftPart += DateFormat.monthAbbr[dtBegin.getMonth()] + ". ";
    }
    if (dtBegin.getFullYear() !== dtEnd.getFullYear()) {
      leftPart += dtBegin.getFullYear() + " ";
    }
    return leftPart + "- " + DateFormat.format(dtEnd);
  }

  static format(dt) {
    return (
      dt.getDate() +
      " " +
      DateFormat.monthAbbr[dt.getMonth()] +
      ". " +
      dt.getFullYear()
    );
  }

  static ddmmyyyy(dt) {
    const dd = dt.getDate();
    const mm = dt.getMonth() + 1;

    return [
      (dd > 9 ? "" : "0") + dd,
      (mm > 9 ? "" : "0") + mm,
      dt.getFullYear()
    ].join(".");
  }

  static dateFrom_ddmmyyyy(str) {
    const [dd, mm, yyyy] = str.split(".");
    if (!(dd && mm && yyyy)) {
      return null;
    }
    const dt = new Date();
    dt.setDate(parseInt(dd, 10));
    dt.setMonth(parseInt(mm, 10) - 1);
    dt.setFullYear(parseInt(yyyy, 10));
    return dt;
  }

  static dateFromEpoch(sec) {
    const dt = new Date();
    dt.setTime(sec * 1000);
    return dt;
  }

  static getEpoch(dt) {
    return Math.floor(dt.getTime() / 1000);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/DateFormat.js